export const NAMESPACE = 'job-container';

export const LS_TEST_DETAILS_COLUMNS_RATIO = 'testDetailsColumnsRatio';
export const INITIAL_COLUMNS_RATIO = 0.6;

export const PREVIEW_MODE_GALLERY = 'gallery';
export const PREVIEW_MODE_VIDEO = 'video';

export const METADATA_SIZE_PARTITION_PX = 400;
export const API_FETCH_INTERVAL = 5000;
export const NOTIFICATION_THROTTLE_INTERVAL = 3000;
export const SEARCH_DEBOUNCE_INTERVAL = 600;
export const FORMAT_FULL_DATETIME = 'yyyy-MM-dd HH:mm:ss';
export const ASSETS_NOT_AVAILABLE_YET = "Job hasn't finished running";

export const MISSING_ASSETS_MESSAGE = 'Assets for this test are no longer available on ' +
  'Sauce Labs servers. Please visit ' +
  '<a href="https://wiki.saucelabs.com/" target="_blank">wiki.saucelabs.com</a> ' +
  'to learn more.';

export const DELETE_JOB_MODAL_ID = 'deleteJobModal';
export const REPORT_JOB_ISSUE_MODAL = 'reportJobIssueModal';

export const COMMAND_LIST_CONTAINER_ID = 'commandListContainer';
export const MIXPANEL_PREFIX = 'Test Details';

export const MIXPANEL_EVENTS = {
  PAGE_OPEN: `${MIXPANEL_PREFIX} Page Open`,
  ENTERED_FULLSCREEN: `${MIXPANEL_PREFIX} Entered Fullscreen`,
  KEBAB_MENU_OPENED: `${MIXPANEL_PREFIX} Kebab Menu Opened`,
};

export const SELENIUM_JOB_METADATA_ORDER_LIST = [
  { label: 'ID', name: 'id' },
  { label: 'Passed', name: 'passed', type: 'boolean' },
  { label: 'Name', name: 'name' },
  { label: 'Build', name: 'build' },
  { label: 'Tags', name: 'tags' },
  { label: 'Browser', name: 'browser' },
  { label: 'Browser version', name: 'browser_version' },
  { label: 'OS', name: 'os' },
  { label: 'Automation backend', name: 'automation_backend' },
  { label: 'Owner', name: 'owner' },
  { label: 'Creation time', name: 'creation_time', type: 'time' },
  { label: 'Start time', name: 'start_time', type: 'time' },
  { label: 'End time', name: 'end_time', type: 'time' },
  { label: 'Modification time', name: 'modification_time', type: 'time' },
  { label: 'Wait time', name: 'wait_time' },
  { label: 'Error', name: 'error' },
  { label: 'Selenium version', name: 'selenium_version' },
  { label: 'Proxied', name: 'proxied', type: 'boolean' },
  { label: 'Assigned tunnel id', name: 'assigned_tunnel_id' },
  { label: 'Base config', name: 'base_config', type: 'json' },
  { label: 'Record screenshots', name: 'record_screenshots', type: 'boolean' },
  { label: 'Record video', name: 'record_video', type: 'boolean' },
  { label: 'Custom Data', name: 'custom-data', type: 'json' },
  { label: 'Public', name: 'public' },
  { label: 'Manual', name: 'manual', type: 'boolean' },
  { label: 'Breakpointed', name: 'breakpointed' },
  { label: 'Screenshots', name: 'screenshots', type: 'screenshot' },
];

export const APPIUM_JOB_METADATA_ORDER_LIST = [
  { label: 'App URL', name: 'remote_app_file_url', type: 'link' },
  { label: 'API Level', name: 'device_descriptor.apiLevel' },
  { label: 'Screen Width', name: 'device_descriptor.resolutionWidth' },
  { label: 'Screen Height', name: 'device_descriptor.resolutionHeight' },
  { label: 'Screen DPI', name: 'device_descriptor.dpi' },
  { label: 'Screen Pixels per Point', name: 'device_descriptor.pixelsPerPoint' },
  { label: 'Screen Size', name: 'device_descriptor.screenSize' },
  { label: 'CPU Type', name: 'device_descriptor.abiType' },
  { label: 'CPU Cores', name: 'device_descriptor.cpuCores' },
  { label: 'CPU Frequency', name: 'device_descriptor.cpuFrequency' },
  { label: 'RAM', name: 'device_descriptor.ramSize' },
  { label: 'Internal Storage', name: 'device_descriptor.internalStorageSize' },
  { label: 'Model number', name: 'device_descriptor.modelNumber' },
  { label: 'ID', name: 'id' },
  { label: 'Passed', name: 'passed', type: 'boolean' },
  { label: 'Name', name: 'name' },
  { label: 'Build', name: 'build' },
  { label: 'Tags', name: 'tags', type: 'json' },
  { label: 'OS', name: 'os' },
  { label: 'Automation backend', name: 'automation_backend' },
  { label: 'Owner', name: 'owner' },
  { label: 'Creation time', name: 'creation_time', type: 'time' },
  { label: 'Start time', name: 'start_time', type: 'time' },
  { label: 'End time', name: 'end_time', type: 'time' },
  { label: 'Modification time', name: 'modification_time', type: 'time' },
  { label: 'Error', name: 'error' },
  { label: 'Proxied', name: 'proxied', type: 'boolean' },
  { label: 'Assigned tunnel ID', name: 'assigned_tunnel_id' },
  { label: 'Base config', name: 'base_config', type: 'json' },
  { label: 'Record screenshots', name: 'record_screenshots', type: 'boolean' },
  { label: 'Record video', name: 'record_video', type: 'boolean' },
  { label: 'Manual', name: 'manual', type: 'boolean' },
  { label: 'Full Device Descriptor', name: 'device_descriptor', type: 'json' },
];

export const PERFORMANCE_TRACE_COMMAND_DELAY_IN_MS = 5 * 1000;
export const SAUCE_JANKINESS_CUSTOM_COMMAND = 'sauce:jankinessCheck';
